export default function Gallery(props) {
  // if (props.images && props.images.length > 0) {
  //   const singleImage = props.images.length === 1 ? "single-image" : "";
  //   return (
  //     <div className="image-gallery--container">
  //       {props.images.map((image) => {
  //         console.log("this is props.images map image", image)
  //         return (
  //           <div className={"image-gallery--image " + singleImage}>
  //             {/*<img src={image.url} />*/}
  //             <img src={image.url} />
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // } else {
  //   return <div></div>;
  // }
    if (props.images) {
        return (
            <div className="image-gallery--container">
                <div className={"image-gallery--image single-image"}>
                    <img src={props.images.url} />
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
}
